export const DesktopRatios = new Map([
  ['widescreen-half-height-(32:9)', 'sm:aspect-32/9'],
  ['fullscreen', 'sm:h-svh'],
  ['anamorphic-(2.39:1)', 'sm:aspect-[2.39/1]'],
  ['netflix-(2:1)', 'sm:aspect-2/1'],
  ['widescreen-(16:9)', 'sm:aspect-video'],
  ['landscape-(3:2)', 'sm:aspect-3/2'],
  ['portrait-(2:3)', 'sm:aspect-2/3'],
  ['square-(1:1)', 'sm:aspect-square'],
]);

export const MobileRatios = new Map([
  ['fullscreen', 'h-svh'],
  ['widescreen-(16:9)', 'aspect-video'],
  ['landscape-(3:2)', 'aspect-3/2'],
  ['portrait-(2:3)', 'aspect-2/3'],
  ['square-(1:1)', 'aspect-square'],
]);
